var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworks = function SvgNetworks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#networks_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 53,
    r: 17,
    fill: "#2F68D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 11.5,
    r: 11.5,
    fill: "#6C9BF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 35,
    r: 8,
    fill: "#B4CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeWidth: 3,
    d: "m22.577 35.526 4-12M40.811 19.738l14 9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeDasharray: "6 6",
    strokeWidth: 3,
    d: "m35.501 46.586 17-6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "networks_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgNetworks;